<template>
    <div class="edit-meta">
        <transition name="popup">
            <div class="popup-mask" v-if="isShowPopup == true" @click.self="clearFile()">
                <div class="popup-content">
                    <i class="close bi bi-x" @click="clearFile()"></i>
                    <div class="title">子帳號設置</div>
                    <div class="content">
                        <div class="file-info">
                            <div class="file-detail">
                                <div class="document-summary">
                                    <div v-if="!isNewCompany" class="file-detail-title pb-2">
                                        <h6>子帳號ID:</h6>
                                        <div>{{ companyId }}</div>
                                    </div>
                                    <div class="file-detail-title">
                                        <h6>子帳號名稱:</h6>
                                        <input type="text" v-model="companyName"/>
                                    </div>
                                    <div class="file-detail-description">
                                        <h6>子帳號服務計劃:</h6>
                                        <select
                                            v-model="planName">
                                            <option v-for="plan in planOption" :key="plan.id">{{ plan.plan_name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="file-detail-title pt-2">
                                        <h6>存量上限:</h6>
                                        <div>{{ formatBytes(storageLimit) }}</div>
                                    </div>
                                    <div class="file-detail-title pt-2">
                                        <h6>每月AI查詢次數上限:</h6>
                                        <div>{{ searchPeriodLimit }}</div>
                                    </div>
                                    <div class="file-detail-description">
                                        <h6>子帳號生效日期:</h6>
                                        <datepicker format="yyyy-MM-dd" v-model="displayPlanStarttime" name="displayPlanStarttime"></datepicker>
                                    </div>
                                    <div v-if="!isNewCompany" class="file-detail-description">
                                        <h6>子帳號失效日期:</h6>
                                        <datepicker format="yyyy-MM-dd" v-model="displayPlanExpirytime" name="displayPlanExpirytime"></datepicker>
                                    </div>
                                    <div v-if="!isNewCompany" class="file-detail-description">
                                        <h6>Admin Email:</h6>
                                        <div v-for="email in adminEmail" :key="email">
                                            {{ email }}
                                        </div>
                                    </div>
                                    <div v-if="isNewCompany" class="file-detail-title pt-3">
                                        <h6>Admin Email:</h6>
                                        <input type="text" v-model="firstAdminEmail"/>
                                    </div>
                                    <div class="file-detail-description">
                                        <h6>Account Lock Type:</h6>
                                        <select
                                            v-model="lockType">
                                            <option v-for="lock in lockTypeOption" :key="lock">{{ lock }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="button-list">
                                    <div class="button cancel-button" @click="clearFile()">
                                        <!-- Cancel -->
                                        {{ $t('cancel') }}
                                    </div>
                                    <div :class="{ 'button': true, 'disable-button': this.isUploading }"
                                        @click="saveFile(fileData)">
                                        <!-- Save -->
                                        {{ $t('save') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import api from '../../api/api.js';
import Datepicker from 'vuejs3-datepicker';

export default {
    name: 'editCompany',
    components: {
        Datepicker
    },
    props: {
        comp_plan_data: { type: Array },
        plan_data: { type: Array },
        admin_data: { type: Array },
        isNewCompany: { type: Boolean },
    },
    data() {
        return {
            isLoading: false,

            isShowPopup: true,
            id: 0,
            companyId: '',
            companyName: '',
            storagePlanStarttime: '',
            storagePlanExpirytime: '',
            storageLimit: 0,
            searchPeriodLimit: 0,
            holderId: 0,
            planName: '',
            planId: 0,
            firstAdminEmail: '',
            planOption: [],
            planAddon: [],
            adminEmail: [],
            lockType: '',
            lockTypeOption: [],

            isUploading: false,

            displayPlanStarttime: '',
            displayPlanExpirytime: '',

            alertEmptyName: '子帳號名稱不能為空',
            alertEmptyPlan: '服務計劃不能為空',
            alertEmptyStarttime: '子帳號生效日期不能為空',
            alertEmptyExpirytime: '子帳號失效日期不能為空',
            alertEmptyEmail: '電郵不能為空',
            alertLockType: 'Account Lock Type 不能為空',
        };
    },
    methods: {
      formatBytes(bytes) {
        if (bytes === 0) return '0 KB';
        const k = 1024;
        // const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const sizes = ['KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        if (i > 3) {
          return parseFloat((bytes / Math.pow(k, 3)).toFixed(2)) + ' ' + sizes[3];
  
        } else {
          return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        }
      },

        clearFile() {
            this.closePopup();
        },

        closePopup() {
            this.isShowPopup = false;
            this.$emit('toggleCompanyPopup');
        },

        async saveFile() {
            if (!this.companyName) {
                alert(this.alertEmptyName);
                return;
            }
            if (!this.planName) {
                alert(this.alertEmptyPlan);
                return;
            }
            if (!this.storagePlanStarttime) {
                alert(this.alertEmptyStarttime);
                return;
            }
            if (this.isNewCompany && !this.firstAdminEmail) {
                alert(this.alertEmptyEmail);
                return;
            }
            if (!this.isNewCompany && !this.storagePlanExpirytime) {
                alert(this.alertEmptyExpirytime);
                return;
            }
            if (!this.lockType) {
                alert(this.alertLockType);
                return;
            }

            this.isUploading = true;
            if (this.isNewCompany) {
                const data = {
                    "companyName": this.companyName,
                    "holderId": this.holderId,
                    "planId": this.planId,
                    "planStarttime": this.storagePlanStarttime,
                    "firstAdminEmail": this.firstAdminEmail,
                    "lockType": this.lockType,
                };
                // console.error(data);
                const response = await api.postCompanyCreate(data);
                if (!response.error) {
                    // this.$router.go(0);
                    this.$emit('refreshList');
                    this.closePopup();
                } else {
                    console.error(response);
                }
            } else {
                const data = {
                    "companyPlanId": this.id,
                    "companyId": this.companyId,
                    "companyName": this.companyName,
                    "planId": this.planId,
                    "planStarttime": this.storagePlanStarttime,
                    "planExpirytime": this.storagePlanExpirytime,
                    "lockType": this.lockType,
                };
                // console.error(data);
                const response = await api.postCompanyUpdate(data);
                if (!response.error) {
                    // this.$router.go(0);
                    this.$emit('refreshList');
                    this.closePopup();
                } else {
                    console.error(response);
                }
            }
            this.isUploading = false;
        },

        adjustHeight() {
            const textarea = this.$refs.descriptionTextarea;
            const lineHeight = parseInt(getComputedStyle(textarea).lineHeight); // ~21 min=31
            const maxHeight = lineHeight * 3 + 10;

            this.$refs.descriptionTextarea.style.height = 'auto';
            if (this.$refs.descriptionTextarea.scrollHeight <= maxHeight) {
                this.$refs.descriptionTextarea.style.height = this.$refs.descriptionTextarea.scrollHeight + 1 + 'px';
            } else {
                this.$refs.descriptionTextarea.style.height = maxHeight + 'px';
            }
        },

    },

    mounted() {
        this.isLoading = true;

        this.comp_plan_data.forEach(companyPlan => {
            this.id = companyPlan.id;
            this.companyId = companyPlan.company_id;
            this.companyName = companyPlan.company_name;
            this.storagePlanStarttime = companyPlan.storage_plan_starttime;
            this.storagePlanExpirytime = companyPlan.storage_plan_expirytime;
            this.storageLimit = companyPlan.storage_limit;
            this.searchPeriodLimit = companyPlan.search_period_limit;
            this.planId = companyPlan.plan_id;
            this.holderId = companyPlan.holder_id;
            this.lockType = companyPlan.lock_type;

            this.displayPlanStarttime = companyPlan.storage_plan_starttime;
            this.displayPlanExpirytime = companyPlan.storage_plan_expirytime;
            
        });

        this.planOption = this.plan_data.filter(i => i.plan_opt == 1 && i.holder_id == this.holderId);
        this.planAddon = this.plan_data.filter(i => i.plan_opt == 0 && i.holder_id == this.holderId);

        this.planName = '';
        if (!this.isNewCompany) {
            this.plan_data.filter(plan => plan.id === this.planId && plan.holder_id == this.holderId).forEach(currPlan => {
                this.planName = currPlan.plan_name;
            });
        }

        this.admin_data.filter(admin => admin.company_id === this.companyId).forEach(rec => {
            this.adminEmail.push(rec.email);
        });

        this.lockTypeOption = ['NOLOCK', '5TIMES', '5TIMES-DAILY'];

        this.isLoading = false;
    },

    watch: {
        'planName'(newVal, oldVal) {
            if (newVal !== oldVal && !this.isLoading) {
                this.plan_data.filter(plan => plan.plan_name === newVal && plan.holder_id == this.holderId).forEach(newPlan => {
                    this.planId = newPlan.id;
                    this.storageLimit = newPlan.storage_limit;
                    this.searchPeriodLimit = newPlan.search_period_limit;
                });
            }
        },
        'displayPlanExpirytime'(newVal, oldVal) {
            if (newVal !== oldVal && !this.isLoading) {
                const newDate = new Date(newVal);
                this.storagePlanExpirytime = new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];
            }
        },
        'displayPlanStarttime'(newVal, oldVal) {
            if (newVal !== oldVal && !this.isLoading) {
                const newDate = new Date(newVal);
                this.storagePlanStarttime = new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];
            }
        }
    },
}
</script>

<style scoped>
.flex-space-between {
    display: flex;
    justify-content: space-between;
}

.popup-mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
}

.popup-mask .popup-content {
    position: absolute;
    width: 30%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    background: #fff;
    overflow: hidden;
    z-index: 1000;
    border-radius: 30px;
    padding: 20px;
    min-width: 530px;
    max-height: 100%;
    overflow-y: scroll;
}

.popup-mask .popup-content::-webkit-scrollbar {
    display: none;
}

.popup-mask .popup-content .close {
    border-radius: 40px;
    width: 18px;
    font-size: 20px;
    float: right;
    color: gray;
    position: absolute;
    right: 23px;
    top: 13px;
    cursor: pointer;
}

.popup-mask .popup-content .title {
    margin: 20px 0;
    font-weight: bold;
    font-size: 15px;
}

.content .file-detail .button {
    border-radius: 20px;
    font-size: 14px;
    color: white;
    cursor: pointer;
    background-color: #F58A32;
    padding: 0px 10px;
    border: unset;
    width: 20%;
    margin: 5px 5px;
    line-height: 35px;
    font-weight: bold;
}

.content .file-detail .button:hover {
    background-color: #F05A27;
}

.content .file-detail .button:active {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
    transform: scale(0.99);
}

.content .file-detail .button.disable-button {
    background-color: darkgray;
    cursor: default;
}

.content .file-detail .button.cancel-button {
    background-color: transparent;
    color: gray;
}

.content .file-detail .document-summary {
    padding: 15px 10px;
    background-color: #F7F7F7;
    border-radius: 10px;
}

.content .file-info {
    width: 100%;
    position: relative;
    padding: 0 10px;
}

.content .file-detail h6 {
    margin: 0;
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: bold;
}

.content .file-detail .file-detail-title {
    text-align: left;
}

.content .file-detail .file-detail-title input {
    width: 100%;
    border: unset;
    outline: unset;
    border-bottom: 1px solid gray;
    padding: 5px 5px;
    font-size: 14px;
    background-color: transparent;
}

.content .file-detail .file-detail-description {
    margin-top: 20px;
    text-align: left;
}

.content .file-detail .file-detail-description textarea {
    width: 100%;
    border: unset;
    border-bottom: 1px solid gray;
    outline: unset;
    padding: 0 5px;
    font-size: 14px;
    resize: none;
    align-content: end;
    background-color: transparent;
}

.content .file-detail .file-detail-description .file-detail-description-textarea textarea {
    width: 100%;
    border: none;
    resize: none;
    outline: none;
    padding: 5px 15px;
}

.content .file-detail .button-list {
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
}

.content .file-detail .ai-generate {
    display: flex;
    justify-content: flex-end;
}

.content .file-detail .ai-generate .ai-generate-button {
    border-radius: 20px;
    background-color: crimson;
    color: white;
    padding: 0 10px;
    width: 115px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    font-size: 12px;
}

.content .file-detail .ai-generate .ai-generate-button:hover {
    background-color: firebrick;
}

.content .file-detail .ai-generate .ai-generate-button:active {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
    transform: scale(0.99);
}

.loading {
    position: relative;
    width: 20px;
    height: 20px;
}

</style>